'use strict';

import PostRobot from 'post-robot';
import BroadcastChannel from 'broadcast-channel';

import { E } from '@itbelcom/custom-error';

const dateFormat = require('dateformat');
const IS_IE = window.navigator.userAgent.match(/(MSIE|Trident)/);

var _DEBUG_LOG_ = false;

/**
 * !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
 * ОЧЕНЬ ВАЖНО:
 *   Не обращаться к свойствам и методам, начинающимся с символов  "_", "$" - это приватные данные и методы.
 *   Не обращаться напрямую к данным, использующимся этим сервисом в sessionStorage, localStorage или иных хранилищах.
 *   Для работы с такими данными использовать ТОЛЬКО ПУБЛИЧНЫЕ методы и свойства объекта.
 * !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
 * 
 * 
 * CrossPost - Сервис для обмена сообщениями между вкладками.
 * Обмен происходит в пределах одинакового origin или между родительским окном и
 * ифреймом (в данном случае могут находиться в различных origin).
 * @constructor
 * @param {Object} o - Опции:
 *   {boolean} [debug=false] - Включить/выключить режим отладки: вывод информации в консоль.
 *   {boolean} [trace=false] - Добавлять к сообщениям служебную информацию о маршруте прохождения сообщения для отладки.
 *   {string} [channelName='CrossPost'] - Имя канала для обмена сообщениям.
 *   {number} [electionTimeout=2000] - ms; Таймаут, в течении которого проводятся выборы.
 *   {number} [requestTimeout=2000] - ms; Таймаут, в течении которого ожидаем получение данных от других владок после запроса.
 *   {string[]} [trustedOrigins=[]] - Список доверенных ориджинов (origin) для кроссдоменной отправки сообщений.
 *   {string[]} [interceptorChannels=[]] - Список каналов которым нужно получать некоторые сообщения (регулируется внутренне) от других каналов.
 */

export { parse, stringify, isString, genId, equalData, getEventListeners, l };

export default function CrossPost(o) {
    var options = Object.assign({
        channelName: 'CrossPost',
        debug: false,
        trace: false,
        electionTimeout: 2000,
        requestTimeout: 2000,
        trustedOrigins: [],
		interceptorChannels: []
    }, o);

    Object.freeze(this.typeConstants);

    this._errorName = 'CrossPostError';
    this._debug = (options.debug === true);
    this._trace = (options.trace === true);
    this._packages = Object.assign({}, options._packages) || {};
    this._id = genId();
    this._DATA_ = undefined; // null;
    this._dataInit = false; // Признак, что данные проинициализированы.
    this._leaderId = this._id;
    this._origin = getOrigin(window.location.origin); //window.location.origin.toLowerCase();
    this._channelName = options.channelName;
    this._trustedOrigins = isString(options.trustedOrigins) ? [options.trustedOrigins] : options.trustedOrigins;
	this._interceptorChannels = isString(options.interceptorChannels) ? [options.interceptorChannels] : options.interceptorChannels;
    this._electionTimeout = options.electionTimeout;
    this._requestTimeout = options.requestTimeout;
    this._events = {};

    if (!Array.isArray(this._trustedOrigins) || !this._trustedOrigins.length) {
        E('<trustedOrigins> option is required.', null, this._errorName, 0);
    }

    if (!this._channelName) {
        E('<channelName> option is required.', null, this._errorName, 0);
    }
	
	if (!Array.isArray(this._interceptorChannels)) {
        E('<interceptorChannels> must be a valid array.', null, this._errorName, 0);
    }

    _DEBUG_LOG_ = this._debug;

    this._trustedOrigins = this._trustedOrigins.reduce(function(r, v) {
        // отбрасываем пустые и не строки
        if (v && isString(v)) {
            try {
                //console.info('>>> URL =', new URL(v));
                var origin = getOrigin(v);
                // отбрасываем дубликаты
                if (origin  && (r.indexOf(origin) === -1)) {
                    //console.info('!!! origin =', origin);
                    r.push(origin);
                }
            } catch(e) {}
        }
        return r;
    }, []);


    this._broadcastChannel = new BroadcastChannel(this._channelName, {
        type: window.BroadcastChannel ? 'native' : 'localstorage', // (optional) enforce a type, oneOf['native', 'idb', 'localstorage', 'node']
        webWorkerSupport: false // (optional) set this to false if you know that your channel will never be used in a WebWorker (increases performance)
    });
	
	this._interceptorBroadcastChannels = [];
	this._interceptorChannels.forEach(function(c) {
		if (c !== this._channelName) {
			var broadcastChannel = new BroadcastChannel(c, {
				type: window.BroadcastChannel ? 'native' : 'localstorage', // (optional) enforce a type, oneOf['native', 'idb', 'localstorage', 'node']
				webWorkerSupport: false // (optional) set this to false if you know that your channel will never be used in a WebWorker (increases performance)
			});
			this._interceptorBroadcastChannels.push(broadcastChannel);
		}
	}, this);

    this._subscribe();

    this.on(this.typeConstants.DATA, this._onData);
    this.on(this.typeConstants.PROMOTE, this._onPromote);
    this.on(this.typeConstants.REQUEST, this._onRequest);
    this.on(this.typeConstants.RESPONSE, this._onResponse);
} /* CrossPost */


/**
 * Типы стандартных(предопределенных) сообщений.
 * Сообщения могут быть иных (пользовательских) типов и их пересылка сервисом не ограничивается.
 * @public
 */
CrossPost.prototype.typeConstants = {
    ////2019.09.11'SEND': 'SEND',         // Событие возникающие при любом исходящем сообщении.
    'ELECTION': 'ELECTION', // Когда выборы завершены и мы выбраны.
    'RESPONSE': 'RESPONSE', // Сообщение-ответ: отправляется в ответ на сообщение-запрос; либо, когда приходит сообщение-ответ.
    'REQUEST': 'REQUEST',   // Сообщение-запрос: отправляется, когда надо получить данные; либо, когда приходит сообщение-запрос.
                            // Например, когда страница (вкладка, ифрейм) открывается и библиотека проинициализировалась.
                            // Этим сообщаем другим открытым страницам, чтобы выслали сохраненную информацию.
    'DATA': 'DATA',         // Сообщение-данные: отправляется, когда отправляем данные.
    'PROMOTE': 'PROMOTE',   // Когда проводим выборы.
}; /* typeConstants */


/**
 * Функция-слушатель (listener) сообщения; в дальнейшем просто <слушатель>.
 * @callback listenerCallback
 * @param {Object|null} data - Данные аутентификации или "пустой" объект в случае, когда не залогинены.
 * @return {boolean} - Если слушатель вернёт true,
 *                     то вызов цепочки слушателей продолжится,
 *                     иначе вызов цепочки слушателей будет прерван и прекратится.
 */


/**
 * Добавление слушателя в конец цепочки.
 * @public
 * @param {string} type - Тип сообщения: см. CrossPost.prototype.typeConstants.
 * @param {listenerCallback} listener - слушатель сообщения.
 */
CrossPost.prototype.on = function(type, listener) {
    this._events[type] = getEventListeners(this, type).concat([listener]);
}; /* on */


/**
 * Добавление разового слушателя в конец цепочки.
 * Вызов произведён будет только раз, затем этот слушатель будет удалён из цепочки.
 * @public
 * @param {string} type - Тип сообщения: см. CrossPost.prototype.typeConstants.
 * @param {listenerCallback} listener - слушатель сообщения.
 */
CrossPost.prototype.once = function(type, listener) {
    this.on(type, function wrap() {
        this.off(type, wrap);
        listener.apply(this, arguments);
    });
}; /* once */


/**
 * Удаление слушателя.
 * @public
 * @param {string} type - Тип сообщения: см. CrossPost.prototype.typeConstants.
 * @param {listenerCallback} listener - слушатель сообщения.
 */
CrossPost.prototype.off = function(type, listener) {
    this._events[type] = getEventListeners(this, type).filter(function(l) {
        return l !== listener;
    });
}; /* off */


/**
 * Вызывов цепочки слушателей заданного типа.
 * @public
 * @param {string} type - Тип сообщения: см. CrossPost.prototype.typeConstants.
 * @param {Object} [data] - Данные, передаваемые слушателю.
 * @param {Object} [meta] - Метаданные, передаваемые слушателю.
 * @returns -
 */
CrossPost.prototype.emit = function(type, data, meta) {
    var i, listeners = getEventListeners(this, type);
    for (i=0; i<listeners.length; i++) {
        if (!listeners[i].call(this, data, meta)) {
            break;
        }
    }
}; /* emit */


/**
 * Сохраняет и рассылает данные, если это неодходимо.
 * @public
 * @param {Object} data - Данные.
 * @param {boolean} [silent] - Определяет, необходимо ли рассылать данные.
 * @param {Object} [meta] - Мета-информация, прикрепляемая к сообщению.
 * @returns -
 */
CrossPost.prototype.setData = function(data, silent, meta) {
    this._dataInit = true;

    l('@cross-post', 'setData: ' + this._id, '_dataInit =', this._dataInit, data, silent, meta);

    if (equalData(this._DATA_, data)) return;

    this._DATA_ = data;

    if (silent === true) return;

    if (meta) {
        this._sendInternal({data: data, meta: meta});
    } else {
        this.send(this._DATA_, this.typeConstants.DATA);
    }
}; /* setData */


/**
 * Возвращает true, если мы лидеры, false - если нет.
 * @public
 * @returns {boolean}
 */
CrossPost.prototype.isLeader = function() {
    return this._leaderId === this._id;
}; /* isLeader */


/**
 * Обрабатывает данные, получаемые при проведении выборов.
 * @private
 * @param {number} electionId - Id проводимых выборов.
 * @param {number} electionExpires - ms, Дата окончания выборов.
 * @param {number} promoteId - Id кандидата
 * @returns {boolean} - true - если обработали и приняли участие в выборах;
 *                      false - если игнорируем данные выборы:
 *                           выборы истекли,
 *                           уже приняли в них участие,
 *                           приняли участие в выборах с более высоким приоритетом...
 */
var n = 0;
CrossPost.prototype._checkPromote = function(electionId, electionExpires, promoteId) {
    var ts = Date.now();
    function dt(v) {
        return v + ':' + (ts * 1000 - v).toString().padStart(8);
    }
    n++;
    l(['@cross-post', 1], '_checkPromote: ' + this._id + ':' + n + '>  ------------------------------------------------------------------------------');
    l(['@cross-post', 1], '_checkPromote: ' + this._id + ':' + n + '> ', this.isLeader(), dt(electionId), dt(promoteId), dt(this._id));

    // ! Принять участие в предлагаемых выборах можно только если:
    //   1) нет текущих выборов;
    //   2) текущие выборы истекли;
    //   3) id предлагаемых выборов меньше id текущих выборов;
    //      в данном случае предлагаемые выборы имеют больший приоритет,
    //      поэтому текущие завершаем и принимаем участие в предлагаемых

    // Если предлагаемые выборы истекли, то игнорируем их
    if (electionExpires <= ts) {
        return false;

    // Проверяем участвуем ли мы в каких-либо выборах (далее - текущие выборы):
    //   this._election = не пустое значение
    } if (this._election) {
        // Если id текущих выборов совпадает с id предлагаемых,
        // то значит мы уже принимаем в них участие и свою кандидатуру предлагали;
        l(['@cross-post', 2], '_checkPromote: ' + this._id + ':' + n + '> ', this.isLeader());
        if (this._election.id === electionId) {
            // поэтому, если выборы еще не завершились, сверяем id текущего лидера с предлагаемым id
            l(['@cross-post', 3], '_checkPromote: ' + this._id + ':' + n + '> ', this.isLeader());
            if (this._election.expires > ts) {
                this._leaderId = Math.min(this._leaderId, promoteId);
                l(['@cross-post', 4], '_checkPromote: ' + this._id + ':' + n + '> ', this.isLeader());
                return true;
            }
            // иначе игнорируем предлагаемые выборы
            return false;

        // Иначе проверяем имеют ли предлагаемые выборы больший приоритет
        // или текущие выборы завершены:
        } else if ((this._election.id > electionId) || (this._election.expires <= ts)) {
            l(['@cross-post', 5], '_checkPromote: ' + this._id + ':' + n + '> ', this.isLeader());
            // если да, то очищаем текущие выборы и определяем лидера;
            // из функции не выходим, так как далее надо будет сохранить информацию о новых выборах
            // и если наша кандидатура удовлетворит условиям - предложить свою.
            this._stopElection();

        // Иначе игнорируем предлагаемые выборы
        } else {
            l(['@cross-post', 6], '_checkPromote: ' + this._id + ':' + n + '> ', this.isLeader());
            return false;
        }
    }

    // Определяем лидера:
    this._leaderId = Math.min(this._id, promoteId);
    l(['@cross-post', 7], '_checkPromote: ' + this._id + ':' + n + '> ', this.isLeader());

    // Сохраняем информацию о предлагаемых выборах, далее будут текущими
    this._election = {
        id: electionId,
        expires: electionExpires
    };

    // и запускаем таймер, который будет отслеживать окончание выборов и генерировать сообщение с результатом
    // и проверять, являемся ли мы лидером:
    this._election.timerId = setTimeout(function () {
        l(['@cross-post', 8], '_checkPromote: ' + this._id + ':' + n + '> ', this.isLeader());
        this._stopElection(true);
    }.bind(this), electionExpires - ts);

    // Если мы промежуточные лидеры, то предлагаем свою кандидатуру;
    if (this.isLeader()) {
        l(['@cross-post', 9], '_checkPromote: ' + this._id + ':' + n + '> ', this.isLeader());
        this.send({
            id: this._election.id,
            expires: this._election.expires,
            promoteId: this._id
        }, this.typeConstants.PROMOTE);
    }

    return true;
}; /* _checkPromote */


/**
 * Завершает выборы и очищает информацию.
 * @private
 */
CrossPost.prototype._stopElection = function(isOver) {
    if (this._election) {
        if (this._election.timerId) {
            clearTimeout(this._election.timerId);
        }
        // isOver = true  - выборы завершены нормально (по таймеру);
        //          иначе - выборы прерваны.
        // Если выборы завершены нормально, то генерируем сообщение внутри вкладки с результатами.
        if (isOver === true) {
            this.emit(
                this.typeConstants.ELECTION,
                { isLeader: this.isLeader() },
                { messageType: this.typeConstants.ELECTION }
            );
        }
    }
    this._election = null;
}; /* _stopElection */


/**
 * Объявляет выборы.
 * @public
 */
CrossPost.prototype.runElection = function() {
    l('@cross-post', 'runElection: ' + this._id + ': ++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++');
    this._stopElection();
    this._checkPromote(genId(), Date.now() + this._electionTimeout, this._id);
}; /* runElection */


/**
 * Завершает ожидания ответа с данными от других вкладок.
 * Если есть другие вкладки, то сохраняются полученные данные,
 * иначе ожидание завершается по таймауту _requestTimeout
 * и выставляется соответственно признак isTimeout.
 * @private
 */
CrossPost.prototype._stopRequest = function(data, isTimeout, error) {
    if (this._request) {
        if (this._request.timerId) {
            clearTimeout(this._request.timerId);
        }
        if (this._request.promise) {
            if (error) {
                this._request.promise._reject(E(error, null, this._errorName));
            } else {
                /**
                 * isTimeout = true - ожидание завершено по таймеру, это значит,
                 * что других вкладок нет либо они не отвечают.
                 * isTimeout = false - данные получены от другой вкладки.
                 */
                isTimeout = (isTimeout === true);
                if (!isTimeout) {
                    /**
                     * Если данные получены не по таймеру(от другой вкладки),
                     * то лидером себя больше не считаем.
                     */
                    this._leaderId = 0;
                }
                this._request.promise._resolve({
                    isTimeout: isTimeout,
                    data: data
                });
            }
        }
    }
    this._request = null;
}; /* _stopRequest */


/**
 * Запрос на получение данных:
 *   Отправляет запрос на получение данных от других вкладок.
 *   Возвращает promise.
 *   Если нет дургих вкладок, то по таймауту (options.requestTimeout) возвращает null.
 *   Если есть несколько ответов(несколько вкладок),
 *   то обрабатываем только первый пришедший ответ, остальные игнорим.
 * @public
 */
CrossPost.prototype.sendRequest = function(data) {
    var res, rej;
    this._request = {
        id: genId(),
        promise: new Promise(function(resolve, reject) {
            res = resolve;
            rej = reject;
        })
    };
    this._request.promise._resolve = res;
    this._request.promise._reject = rej;

    this._request.timerId = setTimeout(function() {
        // Никто не ответил нам
        this._stopRequest(null, true);
    }.bind(this), this._requestTimeout);

    this.send(Object.assign({
        id: this._request.id,
        sourceId: this._id
    }, data), this.typeConstants.REQUEST);

    return this._request.promise;
}; /* sendRequest */


/**
 * Главный слушатель(listener) сообщений: все сообщения первоначально попадают в него.
 * @private
 */
CrossPost.prototype._onMessage = function(method, event) {
    var message = event && event.data;
    var meta = message && message.meta;

    // Если сообщение не содержит служебную информацию, то это не наше сообщение - игнорируем его.
    if (!meta || !meta.messageType || !meta.sended || !meta.sourceId) return;
    // Если получили своё же сообщение, то игнорируем.
    if (meta.sourceId === this._id) return;

    l('@cross-post', '_onMessage(): ' + this._id, message.data, meta);

    if (meta.trace) {
        meta.trace.push({
            kind: 'in',
            method: method,
            step: ++meta.step,
            sourceId: this._id,
            sourceOrigin: (method === 1 ? event.origin : getOrigin(this._origin, IS_IE)),
            targetOrigin: (method === 1 ? this._origin : getOrigin(this._origin, IS_IE)),
            ts: Date.now(),
        });
    }

    // Вызываем цепочку слушателей согласно указанному типу сообщения.
    this.emit(
        meta.messageType,
        message.data ? parse(stringify(message.data), null) : message.data,
        parse(stringify(meta), null)
        ////2019.09.11meta.messageType === this.typeConstants.SEND
    );
}; /* _onMessage */


/**
 * Слушатель сообщения при получении данных.
 * @private
 */
CrossPost.prototype._onData = function(data, meta) {
    l('@cross-post', '_onData: ' + this._id, data, meta);
    this.setData(data, false, meta);
    //this._sendInternal({data: data, meta: meta});
    return true;
}; /* _onData */


/**
 * Слушатель сообщения при выдвижении кандидатуры для участия в выборах.
 * @private
 */
CrossPost.prototype._onPromote = function(data, meta) {
    l('@cross-post', '_onPromote: ' + this._id, data, meta);
    // data is election
    this._checkPromote(data.id, data.expires, data.promoteId);
    this._sendInternal({data: data, meta: meta});
    return true;
}; /* _onPromote */


/**
 * Слушатель сообщения при получении запроса данных от другой вкладки.
 * В ответ шлём имеющиеся у нас данные данные.
 * @private
 */
CrossPost.prototype._onRequest = function(data, meta) {
    l('@cross-post', '_onRequest 0: ' + this._id, '_dataInit =', this._dataInit, data, meta);
    if (!meta.sourceId) {
        l('@cross-post', '_onRequest 1');
        this._stopRequest(null, false, 'Не указан источник!');
        return false;
    } else if (!this._dataInit) {
        // Если данные еще не проинициализированы у нас, то игнорируем все запросы - типа нас нет.
        l('@cross-post', '_onRequest 2');
        return false;
    } else {
        l('@cross-post', '_onRequest 3');
        //setTimeout(function() {
            this.send(this._DATA_, this.typeConstants.RESPONSE, meta.sourceId);
        //}.bind(this), 1);
    }
    return true;
}; /* _onRequest */


/**
 * Слушатель сообщения при ответе на запрос данных другой вкладки
 * или в случае, если нашей вкладке истекло время ожидания.
 * @private
 */
CrossPost.prototype._onResponse = function(data, meta) {
    l('@cross-post', '_onResponse: ' + this._id, data, meta);
    if (!meta.targetId) {
        this._stopRequest(null, false, 'Не указан приемник!');
        return false;
    } else if (meta.targetId !== this._id) {
        // Если это ответ не на наш запрос, то пересылаем его далее.
        //setTimeout(function() {
            this._sendInternal({data: data, meta: meta});
        //}.bind(this), 1);
        return false;
    } else {
        // Если это ответ на наш запрос, то останавливаем ожидание ответа и обрабатываем данные.
        this._stopRequest(data);
    }
    return true;
}; /* _onResponse */


/**
 * Создаёт сообщения на основе данных и типа сообщения.
 * @public
 * @param {Object} data - Данные, непосредственно само тело сообщения.
 * @param {string} [messageType=CrossPost.prototype.typeConstants.DATA] - Тип сообщения: см. CrossPost.prototype.typeConstants.
 * @param {number} [targetId] - Id получателя, необязательное.
 * @returns {Object} Возвращает сформированное сообщение.
 */
CrossPost.prototype.createMessage = function(data, messageType, targetId) {
    if (!data && !messageType) {
        E('Хотя бы один параметр должен быть указан: data или messageType.', null, this._errorName, 0);
    }

    messageType = messageType || this.typeConstants.DATA;

    var meta = {
        messageType: messageType,
        // Отладочная информация
        id: genId(),            // Уникальный идентификатор сообщения
        sourceId: this._id,     // Вкладка-источник сообщения
        ts: Date.now(),         // Время создания сообщения (в миллисекундах).
        sended: {},             // Список доменов, которым отправляли сообщение (обязательно):
                                //    1 - отослано через Window.postMessage (кроссдоменно: iframe, popup)
                                //    2 - отослано через BroadcastChannel (для своего домена)
    };

    if (targetId) {
        meta.targetId = targetId;
    }

    if ((messageType === this.typeConstants.REQUEST) || (messageType === this.typeConstants.RESPONSE)) {
        meta.packages = this._packages;
    }

    if (this._trace) {
        // Отладочная информация
        meta.step = 0;
        meta.trace = []; // трассировка маршрута, который проходит сообщение: {[CrossPost._id: ts, ...]}
    }

    return {
        data: data, //data || null,
        meta: meta
    };
}; /* createMessage */


/**
 * Создаёт и отправляет сообщение на основе данных и типа сообщения.
 * @public
 * @param {Object} data - Данные, непосредственно само тело сообщения.
 * @param {string} messageType - Тип сообщения: CrossPost.prototype.typeConstants.
 * @param {number} [targetId] - Id получателя, необязательное.
 * @returns {boolean} В случае успеха вернет true.
 */
CrossPost.prototype.send = function(data, messageType, targetId, enableInterceptors) {
    var message = this.createMessage(data, messageType, targetId);
    return this._sendInternal(message, enableInterceptors);
}; /* send(..) */


/**
 * Отправляет сообщения окнам(вкладкам, ифреймам), находящимся в одинаковом домене с текущим окном
 * или для доменов из trustedOrigins в случае ифрейма или родительского окна.
 * @private
 * @param {string} message - Текст сообщения.
 * @return -
 */
CrossPost.prototype._sendInternal = function(message, enableInterceptors) {
    var meta = message.meta;
    l(['@cross-post', 1], 'sendInternal(): ' + this._id
        + '; exit1=' + (!meta || !meta.messageType || !meta.sended || !meta.sourceId)
        + '; exit2=' + (meta.targetId === this._id)
        + '; message =', message);

    // Если сообщение не содержит служебную информацию, то это не наше сообщение - игнорируем его.
    if (!meta || !meta.messageType || !meta.sended || !meta.sourceId) return false;
    // Если пытаемся отправить себе же свое сообщение, то игнорируем.
    if (meta.targetId === this._id) return false;

    var origin = getOrigin(this._origin, IS_IE);
    var sended = meta.sended;
    var ts = Date.now();
    var useBroadcastChannel = false;

    meta.trace && meta.step++;

    l(['@cross-post', 2], 'sendInternal(): (sended[origin] !== 2) -> ' + (sended[origin] !== 2));
    if (sended[origin] !== 2) {
        // Сообщение будем слать всем вкладкам и ифреймам находящимся в одинаковом домене;
        // не зависимо от того есть они или нет их, так как не знаем этого.
        sended[origin] = 2;
        if (meta.trace) {
            meta.trace.push({
                kind: 'out',
                method: 2,
                step: meta.step,
                sourceId: this._id,
                sourceOrigin: origin,
                targetOrigin: origin,
                ts: ts,
            });
        }
        useBroadcastChannel = true;
    }


    // Получаем список доверенных ифреймов (iframe), которым будем слать сообщение.
    // !Свой домен исключаем, так как находящимся в одинаковых доменах рассылаем с помощью BroadcastChannel.
    var trustedWindows = getTrustedFrames(window, this._trustedOrigins.filter(function(value) {
        if ((!sended[value]) && (sended[getOrigin(value, IS_IE)] !== 2)) {
            //sended[value] = 1;
            return true;
        }
        return false;
    }));

    // Если есть родительское окно, то его так же добавляем в список - будем слать сообщение.
    if (window.parent && (window.parent !== window)) {
        var parentOrigin = getOrigin(document.referrer); /*new URL(document.referrer).origin.toLowerCase();*/
        // !Свой домен исключаем, так как находящимся в одинаковых доменах рассылаем с помощью BroadcastChannel.
        // !Если не является доверенным, то так же исключаем - так как на стороннем сайте включили нас в ифрейм.
        if ((!sended[parentOrigin]) && (sended[getOrigin(parentOrigin, IS_IE)] !== 2) && (this._trustedOrigins.indexOf(parentOrigin) !== -1)) {
            //sended[parentOrigin] = 1;
            trustedWindows.push({
                win: window.parent,
                origin: parentOrigin
            });
        }
    }

    trustedWindows = trustedWindows.reduce(function(r, trusted) {
        if ((!sended[trusted.origin]) && (sended[getOrigin(trusted.origin, IS_IE)] !== 2)) {
            r.push(trusted);
            sended[trusted.origin] = 1;
            if (meta.trace) {
                meta.trace.push({
                    kind: 'out',
                    method: 1,
                    step: meta.step,
                    sourceId: this._id,
                    sourceOrigin: this._origin,
                    targetOrigin: trusted.origin,
                    ts: ts,
                });
            }
        }
        return r;
    }.bind(this), []);

    l(['@cross-post', 3], 'sendInternal(): ' + this._id + ' ; trustedWindows =', trustedWindows);

    var isSended = false;
    if (useBroadcastChannel) {
        // Сообщение будем слать всем вкладкам и ифреймам находящимся в одинаковом домене;
        // не зависимо от того есть они или нет их, так как не знаем этого.
        this._broadcastChannel.postMessage(message);
        isSended = true;
		
		if (enableInterceptors) {
			this._interceptorBroadcastChannels.forEach(function (bc) {
				bc.postMessage(message);
			}, this);
		}
    }

    trustedWindows.forEach(function(trusted) {
        l(['@cross-post', 4], 'sendInternal(): ' + this._id + ' : START: trusted =', trusted);

        PostRobot.send(trusted.win, this._channelName, message, {
            domain: trusted.origin,
            timeout: 2000
        });

        isSended = true;
    }, this);

    l(['@cross-post', 5], 'sendInternal(): ' + this._id + ' ; isSended =' + isSended);
    /* ////2019.09.11
    if (isSended) {
        this.emit(this.typeConstants.SEND, parse(stringify(message.data)), parse(stringify(meta)), true);
    }
    */
    return true;
} /* sendInternal */


/**
 * Подписывается на получение сообщений от окон(вкладок, ифреймов) находящихся в одном домене
 * или для доменов из trustedOrigins в случае ифрейма или родительского окна.
 * @private
 * @return -
 */
CrossPost.prototype._subscribe = function() {
    // BroadcastChannel
    this._broadcastChannel.onmessage = function(data) {
        return this._onMessage.bind(this, 2)({data: data});
    }.bind(this);

    // PostRobot
    this._trustedOrigins.forEach(function(trustedOrigin) {
        PostRobot.on(this._channelName, {
            //window: ..., // слушаем не зависимо от окна, так как могут открываться новые и закрываться старые.
            domain: trustedOrigin,
        }, this._onMessage.bind(this, 1));
    }, this);

}; /* subscribeMessage() */


/**
 * Вспомогательные функции.
 */
function parse(value, defaultValue) {
    try { return JSON.parse(value) || defaultValue; } catch(e) { return defaultValue; }
}


function stringify(value) {
    return JSON.stringify(value);
}


function isString(value) {
    return typeof value === 'string' || value instanceof String;
}


function genId() {
    return Math.round(1000 * (Date.now() + Math.random()));
}


function equalData(a, b) {
    if (a === b) return true;

    if (a && b && (typeof a == 'object') && (typeof b == 'object')) {
        return a.$id === b.$id;
    }
    return false;
}


function getEventListeners(obj, type) {
    return obj._events[type] || (obj._events[type] = []);
}

// parseUri 1.2.2
// (c) Steven Levithan <stevenlevithan.com>
// MIT License

function parseUri (str) {
	var	o   = parseUri.options,
		m   = o.parser[o.strictMode ? "strict" : "loose"].exec(str),
		uri = {},
		i   = 14;

	while (i--) uri[o.key[i]] = m[i] || "";

	uri[o.q.name] = {};
	uri[o.key[12]].replace(o.q.parser, function ($0, $1, $2) {
		if ($1) uri[o.q.name][$1] = $2;
	});

	return uri;
};

parseUri.options = {
	strictMode: false,
	key: ["source","protocol","authority","userInfo","user","password","host","port","relative","path","directory","file","query","anchor"],
	q:   {
		name:   "queryKey",
		parser: /(?:^|&)([^&=]*)=?([^&]*)/g
	},
	parser: {
		strict: /^(?:([^:\/?#]+):)?(?:\/\/((?:(([^:@]*)(?::([^:@]*))?)?@)?([^:\/?#]*)(?::(\d*))?))?((((?:[^?#\/]*\/)*)([^?#]*))(?:\?([^#]*))?(?:#(.*))?)/,
		loose:  /^(?:(?![^:@]+:[^:@\/]*@)([^:\/?#.]+):)?(?:\/\/)?((?:(([^:@]*)(?::([^:@]*))?)?@)?([^:\/?#]*)(?::(\d*))?)(((\/(?:[^?#](?![^?#\/]*\.[^?#\/.]+(?:[?#]|$)))*\/?)?([^?#\/]*))(?:\?([^#]*))?(?:#(.*))?)/
	}
};

function getOrigin(v, asIE) {
    if (!v) return '';

    var url;
    var origin = '';

    try {
        if (typeof(URL) === 'function') {
		url = new URL(v);
	} else {
		// IE can really be one lovely piece sometimes
		parseUri.options.strictMode = true;
		var puObj = parseUri(v);
		var urlProtocol = puObj.protocol + (puObj.protocol.indexOf(':') !== puObj.protocol.length - 1 ? ':' : '');
		url = { hostname: puObj.host, port: puObj.port, protocol: urlProtocol, origin: urlProtocol + '//' + puObj.host + (puObj.port && puObj.port !== '' ? ':' + puObj.port : '') };
	}
        origin = url.origin.toLowerCase();
    } catch(e) {}

    if (!url || (origin === 'null')) return '';

    return asIE ? url.protocol + '//' + url.hostname : origin;
}


function getTrustedFrames(win, trustedOrigins) {
    var frames, result = [];
    try {
        frames = win.document.getElementsByTagName('IFRAME');
    } catch (err) {}

    if (!frames) return result;

    for (var i = 0; i < frames.length; i++) {
        var frame = void 0;
        try {
            frame = frames[i];
        } catch (err) {
            continue;
        }
        if (!frame.src || !frame.contentWindow) continue;
        var origin = getOrigin(frame.src);
        if (!origin || (trustedOrigins.indexOf(origin) === -1)) continue;
        result.push({
            win: frame.contentWindow,
            origin: origin
        });
    }
    return result;
}


function l() {
    if (!_DEBUG_LOG_) return;

    var consoleType = 'info';
    var d = dateFormat(new Date(), 'HH:MM:ss:l');
    var params = typeof(arguments[0]) === 'object' ? arguments[0] : [arguments[0]];
    var args = ['%c>>> ' + d + ' ' + params[0] + ':', 'color: #fc03c6;'];

    if (Number.isInteger(params[1])) {
        if (params[1] < 10) {
            args[0] += ' ';
        }
        args[0] += ' ' + params[1].toString() + '::';
    }
    if (isString(params[2])) {
        consoleType = params[2];
    }
    if (isString(params[3])) {
        args[1] = params[3];
    }
    for (var i = 1; i < arguments.length; i++) {
        args.push(arguments[i]);
        /*
        if (typeof(arguments[i]) === 'object') {
            args.push(JSON.parse(JSON.stringify(arguments[i])));
        } else {
            args.push(arguments[i]);
        }
        */
   }
    console[consoleType].apply(console, args);
}



//////////////////
// WEBPACK FOOTER
// ../node_modules/@itbelcom/cross-post/src/cross-post.js
// module id = 720
// module chunks = 0 1 2